import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { FetchSubprovider } from '@bitski/provider-engine';
import retry from 'async/retry';
import { AUTHENTICATED_METHODS, RETRIABLE_ERRORS, UNAUTHORIZED_ERRORS } from '../constants';
import { ServerError } from '../errors/server-error';
/*
 * Subprovider that fetches over HTTP and manages authentication headers
 */

export var AuthenticatedFetchSubprovider = /*#__PURE__*/function (_FetchSubprovider) {
  _inherits(AuthenticatedFetchSubprovider, _FetchSubprovider);

  var _super = _createSuper(AuthenticatedFetchSubprovider);

  function AuthenticatedFetchSubprovider(rpcUrl, debug, accessTokenProvider) {
    var _this;

    var defaultHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, AuthenticatedFetchSubprovider);

    _this = _super.call(this, {
      rpcUrl: rpcUrl
    });
    _this.authenticatedMethods = AUTHENTICATED_METHODS;
    _this.accessTokenProvider = accessTokenProvider;
    _this.defaultHeaders = defaultHeaders;
    return _this;
  }

  _createClass(AuthenticatedFetchSubprovider, [{
    key: "handleRequest",
    value: function handleRequest(payload, next, end) {
      if (this.requiresAuthentication(payload)) {
        return this.handleAuthenticatedRequest(payload, next, end);
      } else {
        return this.handleUnauthenticatedRequest(payload, next, end);
      }
    }
  }, {
    key: "handleAuthenticatedRequest",
    value: function handleAuthenticatedRequest(payload, next, end) {
      var _this2 = this;

      this.accessTokenProvider.getAccessToken().then(function (accessToken) {
        var parameters = _this2.generateParameters(payload, accessToken);

        return _this2.sendRequest(parameters, next, end);
      }).catch(function (error) {
        end(error);
      });
    }
  }, {
    key: "handleUnauthenticatedRequest",
    value: function handleUnauthenticatedRequest(payload, next, end) {
      var parameters = this.generateParameters(payload);
      return this.sendRequest(parameters, next, end);
    }
  }, {
    key: "requiresAuthentication",
    value: function requiresAuthentication(payload) {
      return this.authenticatedMethods.some(function (method) {
        return method === payload.method;
      });
    }
  }, {
    key: "generateParameters",
    value: function generateParameters(payload, accessToken) {
      // overwrite id to not conflict with other concurrent users
      var newPayload = this.createPayload(payload); // remove extra parameter from request

      delete newPayload.origin;
      var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      headers = Object.assign({}, headers, this.defaultHeaders);
      var originDomain = payload.origin;

      if (this.originHttpHeaderKey && originDomain) {
        headers[this.originHttpHeaderKey] = originDomain;
      }

      if (accessToken) {
        headers.Authorization = "Bearer ".concat(accessToken);
      }

      var requestParameters = {
        body: JSON.stringify(newPayload),
        headers: headers,
        method: 'POST'
      };
      return requestParameters;
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(parameters, next, end) {
      var _this3 = this;

      retry({
        errorFilter: this.isErrorRetriable,
        interval: 1000,
        times: 5
      }, function (cb) {
        return _this3._submitRequest(parameters, cb);
      }, function (err, result) {
        // ends on retriable error
        if (err && _this3.isErrorRetriable(err)) {
          var retriesExhaustedErr = new ServerError(err.message, 200, _this3.rpcUrl, true);
          return end(retriesExhaustedErr);
        }

        if (err && _this3.isUnauthorizedError(err)) {
          return _this3.accessTokenProvider.invalidateToken().then(function () {
            return end(err);
          });
        } // otherwise continue normally


        return end(err, result);
      });
    }
  }, {
    key: "isErrorRetriable",
    value: function isErrorRetriable(err) {
      var errMsg = err.toString();
      return RETRIABLE_ERRORS.some(function (phrase) {
        return errMsg.includes(phrase);
      });
    }
  }, {
    key: "isUnauthorizedError",
    value: function isUnauthorizedError(err) {
      return UNAUTHORIZED_ERRORS.some(function (phrase) {
        return err.message.includes(phrase);
      });
    }
  }]);

  return AuthenticatedFetchSubprovider;
}(FetchSubprovider);